<template>
  <div class="bgf4">
    <div class="abc">
    <div class="box bgfff" style="display:block;margin:20px auto;padding:20px;">
      <!-- 左侧菜单栏 -->
      <div class="fleft  cleft">
        <!-- <div class="firmTitle bgblue">
          <img src="../../images/jt.png">
          <span style="margin-left:10px">专题分类</span>
        </div> -->
        <ul class="cleftUl">
          <a-menu mode="inline" :open-keys.sync="openKeys"  @click="handleClick" class="mezt" :default-selected-keys="openKeys1">
            <template v-for="item in treeList" >
              <!-- <a-sub-menu class="toggle"
                :key="item.id"
              > -->
                <!-- <span slot="title" >{{ item.label }}</span> -->
                <!-- <template v-for="i in item.children" style="display: none;"> -->
                  <a-menu-item class="ali"
                    :key="item.id"
                  >
                    <span>{{ item.label }}</span>
                  </a-menu-item>
                <!-- </template> -->
              <!-- </a-sub-menu> -->
            </template>
          </a-menu>
        </ul>
      </div>
      <!-- 右侧表格部分 -->
      <div class="fright  cright">
        <h3 class="qytr" v-if="showDetail==false">
          <span class="blueBlock"></span>
          专题标准
        </h3>
        <div class="search" v-if="showDetail==false">
          <input type="text" class="searchInput" placeholder="请输入标准号、中文名称、英文名称、标准状态、范围、关联标准中任意关键词搜索" v-model="name" @keyup.enter="queryname">
          <button @click="queryname" >搜索</button>
        </div>
        <a-table class="ta" :pagination="false"
        :customRow="customRow"
        :columns="columns" :data-source="data" v-if="showDetail==false">
          <span slot="action" slot-scope="text, record">
            <a style="color: #1890FF;font-weight:normal;font-size:16px" @click="handleRead(record)" v-if="record.leibie
            =='D' || record.leibie=='C' || record.leibie=='G' || record.leibie=='T'">阅读</a>
            <a-divider type="vertical" v-if="(record.leibie=='D' || record.leibie=='C' || record.leibie=='G' || record.leibie=='T')"/>
            <a style="color: #1890FF;font-weight:normal;font-size:16px" @click="download(record)"
            v-if="(record.leibie=='D' || record.leibie=='C' || record.leibie=='G' || record.leibie=='T')"
            >下载</a>
          </span>
          <span slot="bzh" slot-scope="text, record">
            <a class="bzha" @click="bzdetial(record.id)">{{record.a100}}</a>
          </span>
        </a-table>
        <div class="fy" v-if="data.length>0 && showDetail==false">
          <span style="margin-top:4px;margin-right:5px">共&nbsp;{{total}}&nbsp;条记录</span>
          <div class="fir"><a @click="btnfir" :disabled="disabled" ref="fa">首页</a></div>
          <a-config-provider :locale="locale">
          <a-pagination  :total="ipagination.total" :item-render="itemRender" :pagination="ipagination"
          v-model="ipagination.pageNo" @change='changePage'>
          </a-pagination>
          </a-config-provider>
          <div class="end"><a ref="end" :disabled="disablede" @click="endbtn">末页</a></div>
          <span style="margin-left:5px" v-if="tjcx==1">跳至&nbsp;<a-input type="text" v-model="text" @blur="changeText" style="width:50px;border:normal" />&nbsp;页</span>
        </div>
        <h3 class="qytr" v-if="showDetail==true">
          <span class="blueBlock"></span>
          标准详情
        </h3>
        <AquaticSpecialDetial v-if="showDetail==true"></AquaticSpecialDetial>
      </div>
    </div>
    </div>
  </div>
</template>



<script>
import http from '../../js/axios'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import AquaticSpecialDetial from './AquaticSpecialDetial.vue'

export default {
  components:{
    AquaticSpecialDetial
  },
  name: 'App',
  data(){
    return{
      disabled:false,
      disablede:false,
      locale: zhCN,
      ipagination:{
        current: 1,
        pageNo:1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      treeList: [
      ],
      openKeys: [],
      openKeys1:[],
      columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            align:"center",
            width:70,
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'标准号',
            align:"left",
            dataIndex: 'bzh',
            width:150,
            ellipsis: true,
            scopedSlots: { customRender: 'bzh' }
          },
          {
            title:'标准名称',
            align:"left",
            dataIndex: 'a298',
            ellipsis: true,
            width:155
          },
          {
            title:'发布日期',
            align:"center",
            dataIndex: 'a101',
            width:100
          },
          {
            title:'实施日期',
            align:"center",
            dataIndex: 'a205',
            width:100
          },

          // {
          //   title:'中文名称',
          //   align:"center",
          //   dataIndex: 'a298'
          // },

          {
            title:'标准状态',
            align:"center",
            dataIndex: 'a200',
            width:70,
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:130,
            scopedSlots: { customRender: 'action' }
          }
        ],
      data:[],
      default:[],
      id:'',
      total:0,
      text:null,
      name:'',
      tjcx:1,
      selectMenu: '1351155880615170049',
      // 1351155880615170049   1351156070197710850 1351156106117730306
      showDetail:false,
    }
  },
  computed:{

  },
  created(){
    if(this.$route.query.id){//显示详情
      this.showDetail = true;
    }
    let a = this.$route.params.sczt
    this.querytree(a)
    if(this.ipagination.total=='0'){
      this.disablede = true
      this.disabled = true
    }

  },
  mounted () {

  },
  watch: {
    openKeys(val) {

    },
    ipagination: {
        handler(newVal) {
            setTimeout(() => {
              if(newVal.pageNo=='1'){
              this.disabled = true
              this.$refs.fa.style.color = '#bfbfbf'
              }else{
                this.disabled = false
                this.$refs.fa.style.color = '#595959'
              }


            let end = newVal.total/newVal.pageSize
            end = Math.ceil(end)
            if(newVal.current!=end){
              this.disablede = false
              this.$refs.end.style.color = '#595959'
            }else{
              this.$refs.end.style.color = '#bfbfbf'
              this.disablede = true
            }
            }, 50);
        },
        deep: true
    }
  },
  methods: {
    changeName(e){
      this.name = e.target.value
    },
    queryname(){
      if(this.text!=null){
        this.text=null
      }
      if(this.name==null || this.name==''){
        this.tjcx=1
      }else{
        this.tjcx = 2
      }
      this.ipagination.pageNo = 1
      http.get('/querylistBySpecialId',{params:{special_id:this.id,pageNo:this.ipagination.pageNo,pageSize:this.ipagination.pageSize,name:this.name}}
      ).then((res) => {
          this.data = res.data.result.records
          this.ipagination.total = res.data.result.total
          this.ipagination.current = res.data.result.current
          this.total = res.data.result.total
      })
    },
    changeText(e){
      // if(e.target.value==null || e.target.value==''){
      //   this.ipagination.current = 1
      //   this.ipagination.pageNo = 1
      //   this.queryBySpecialId(this.id)
      // }else{

      // }
      var i = parseInt(e.target.value)
      let end = this.total/this.ipagination.pageSize
      end = Math.ceil(end)
      if(i>end){
        this.ipagination.current = end
        this.ipagination.pageNo = end
        this.text = null
      }else if(i==0){
        this.ipagination.current = 1
        this.ipagination.pageNo = 1
        this.text = null
      }else if(e.target.value==null || e.target.value==''){

      }
      else{
        this.ipagination.current = i
        this.ipagination.pageNo = i
        this.text = i
      }
      this.queryBySpecialId(this.id)

    },
    bzdetial(id){
      this.showDetail = true
      // window.open('aquaticdetial?id='+id)
      let path = this.$route.fullPath;
      this.$router.push({ path, query: {id: id, selectMenu: this.selectMenu}});
    },
    endbtn(){
      if(this.text!=null){
        this.text=null
      }
      let end = this.ipagination.total/this.ipagination.pageSize
      end = Math.ceil(end)
      this.ipagination.pageNo = end
      this.queryBySpecialId(this.id)
    },
    btnfir(){
      if(this.text!=null){
        this.text=null
      }
      this.ipagination.pageNo = 1
      this.queryBySpecialId(this.id)
    },
    changePage(e){
      if(this.text!=null){
        this.text=null
      }
      this.ipagination.pageNo = e
      this.queryBySpecialId(this.id)
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return <div class="pre"><a>上一页</a></div>;
      } else if (type === 'next') {
        return <div class="next"><a>下一页</a></div>;
      }
      return originalElement;
    },
    customRow(record, index) {
      return {
        style: {
          // // 字体颜色
          // color: record.remarkDesc ? record.remarkDesc.fontColor : '#262626',
          // 行背景色
          'background-color': index % 2 == 0 ? '#FFFFFF' : '#eff2f4',
        }
      }
    },
    handleRead(record){
      var arr = document.cookie.split('; ');
        if(arr.length>1){
          http.post('/getUserQuanXian',{userid:this.$cookies.get('userid')}).then((res) => {
            if(record.leibie == null || record.leibie === undefined || record.leibie === ""){
              this.$message.warning("出现异常，请重试！");
            }else if(record.leibie=='D'){//地方标准
              if(res.data.authority != null && res.data.authority.indexOf("5") != -1){
                this.previewBzFileInfo(record)
              } else {
                this.$message.warning("您没有此操作权限，请联系管理员添加！");
              }
            }else if(record.leibie=='G'){//国家标准
              if(res.data.authority != null && res.data.authority.indexOf("1") != -1){
                this.previewBzFileInfo(record)
              } else {
                this.$message.warning("您没有此操作权限，请联系管理员添加！");
              }
            }else if(record.leibie=='C'){//行业标准
              if(res.data.authority != null && res.data.authority.indexOf("3") != -1){
                this.previewBzFileInfo(record)
              } else {
                this.$message.warning("您没有此操作权限，请联系管理员添加！");
              }
            }else if(record.leibie=='T'){//团体标准
              if(res.data.authority != null && res.data.authority.indexOf("7") != -1){
                this.previewBzFileInfo(record)
              } else {
                this.$message.warning("您没有此操作权限，请联系管理员添加！");
              }
            }
        });
          // console.log("可以阅读！")
          // console.log("readrecord",record)
          // this.previewBzFileInfo(record)
        }else{
          this.$message.warning("您尚未登录，请登录后再试！")
        }
    },
    previewBzFileInfo(record){
      sessionStorage.setItem("bzId", record.id);
      sessionStorage.setItem("a100", record.a100);
      sessionStorage.setItem("a298", record.a298);
      sessionStorage.setItem("a302", record.a302);
      sessionStorage.setItem("leibie", record.leibie);
      window.open("static/pdfjs/web/viewer.html");
    },
    download(record){
      var arr = document.cookie.split('; ');
        if(arr.length>1){
          // console.log("可以阅读！")
          // this.downloadBzFileInfo(record)
          http.post('/getUserQuanXian',{userid:this.$cookies.get('userid')}).then((res) => {
            if(record.leibie == null || record.leibie === undefined || record.leibie === ""){
              this.$message.warning("出现异常，请重试！");
            }else if(record.leibie=='D'){//地方标准
              if(res.data.authority != null && res.data.authority.indexOf("6") != -1){
                this.downloadBzFileInfo(record)
              } else {
                this.$message.warning("您没有此操作权限，请联系管理员添加！");
              }
            }else if(record.leibie=='G'){//国家标准
              if(res.data.authority != null && res.data.authority.indexOf("2") != -1){
                this.downloadBzFileInfo(record)
              } else {
                this.$message.warning("您没有此操作权限，请联系管理员添加！");
              }
            }else if(record.leibie=='C'){//行业标准
              if(res.data.authority != null && res.data.authority.indexOf("4") != -1){
                this.downloadBzFileInfo(record)
              } else {
                this.$message.warning("您没有此操作权限，请联系管理员添加！");
              }
            }else if(record.leibie=='T'){//团体标准
              if(res.data.authority != null && res.data.authority.indexOf("8") != -1){
                this.downloadBzFileInfo(record)
              } else {
                this.$message.warning("您没有此操作权限，请联系管理员添加！");
              }
            }
          });
        }else{
          this.$message.warning("您尚未登录，请登录后再试！")
        }
    },
    downloadBzFileInfo(record){
      http.post(
          '/downloadFile',{
              id: record.id
          }
      ).then((res) => {
          if(res.data.code == "1000"){//调用正常
              window.open(http.baseURL + "/downloadBzsj?id="+record.id+"&a100="+record.a100+"&a298="+record.a298+"&a302="+record.a302+"&leibie="+record.leibie, "_self");
          } else {
              this.$message.error(res.data.msg);
          }
      })
    },
    handleClick(e) {
      if(this.text!=null){
        this.text=null
      }
      if(this.ipagination.pageNo!=1){
        this.ipagination.pageNo=1
      }
      this.id = e.key
      this.queryBySpecialId(e.key)
      this.selectMenu = e.key;
    },
    queryBySpecialId(value){
      if(this.showDetail==true){
        this.showDetail=false
      }
      http.get('/querylistBySpecialId',{params:{special_id:value,pageNo:this.ipagination.pageNo}}
      ).then((res) => {
          this.data = res.data.result.records
          this.ipagination.total = res.data.result.total
          this.ipagination.current = res.data.result.current
          this.total = res.data.result.total
      })
    },
    querytree(value){
      http.post(
            '/ztfw-type-all',{}
        ).then((res) => {
            this.treeList = res.data.data
            // let data = []
            this.openKeys = []
            if((value==null || value=="") && this.showDetail==false){
              // this.openKeys.push(this.treeList[0].id)
              this.openKeys1.push(this.treeList[0].id)
              this.id=this.treeList[0].id
            }
            else{
              for(var a = 0;a<this.treeList.length;a++){
              if(value==this.treeList[a].label && this.showDetail==false){
                // data.push(this.treeList[a].id)
                // this.openKeys = data
                this.openKeys1.push(this.treeList[a].id)
                this.id=this.treeList[a].id
                break
              }else if(this.$route.query.selectMenu){
                this.queryD(this.$route.query.selectMenu)
                this.openKeys1.push(this.$route.query.selectMenu)
                this.id=this.$route.query.selectMenu
              }
            }
            }
            if(this.showDetail==false){
              this.queryBySpecialId(this.id)
            }
        })
    },
    queryD(id){
      http.get('/queryByIdMenu',{params:{id:id}}
      ).then((res) => {
          this.openKeys.push(res.data.result.pid)
      })
    },
  },
}
</script>


<style scoped>
@import "../../config/AquaticSpecial.css"

</style>







// WEBPACK FOOTER //
// src/views/aquaticspecial/AquaticSpecial.vue